import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-parveen',
  templateUrl: './parveen.component.html',
  styleUrls: ['./parveen.component.scss']
})
export class ParveenComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getParveen();
  }

}
